import { useQuery } from "@tanstack/react-query";
import { Link } from "react-router-dom";

import { fetchActionItems } from "@/api/endpoints";
import { ActionQueue } from "@/components/ActionQueue";
import { usePageTitle } from "@/hooks/usePageTitle";

export function OperatorHome(): JSX.Element {
  usePageTitle("Home");
  const query = useQuery({ queryKey: ["action-items"], queryFn: () => fetchActionItems() });

  if (query.isLoading) {
    return (
      <div className="space-y-4">
        <div className="skeleton h-8 w-64" />
        <div className="grid gap-4 sm:grid-cols-3">
          <div className="skeleton h-28" />
          <div className="skeleton h-28" />
          <div className="skeleton h-28" />
        </div>
        <div className="skeleton h-64" />
      </div>
    );
  }
  if (query.isError || !query.data) {
    return (
      <div className="card">
        <p className="text-severity-high">Couldn&apos;t load your dashboard.</p>
        <p className="text-sm text-ink-300 mt-1">
          Try again in a moment. If it keeps failing, state (FDEP) data may be
          temporarily unavailable.
        </p>
        <button
          type="button"
          className="btn-primary text-xs mt-3"
          onClick={() => void query.refetch()}
        >
          Retry
        </button>
      </div>
    );
  }

  return (
    <div className="space-y-6">
      <header className="flex items-baseline justify-between flex-wrap gap-2">
        <h1 className="text-2xl font-semibold">What needs attention</h1>
        <Link to="/systems" className="text-sm text-ink-300 hover:text-ink-100">
          All systems →
        </Link>
      </header>
      <ActionQueue data={query.data} />
    </div>
  );
}
